import React from 'react'
import { browserHistory, match } from 'react-router';

import NavLink from '../Routes/NavLink'
import {BootstrapTable, TableHeaderColumn} from 'react-bootstrap-table';

import { tenants } from '../../core/controllers/tenants'
import { modal } from '../../core/utilities/modal'

export default class TenantsList extends React.Component {
    constructor(props) {
        super(props);
        this.index = 0;

        this.lastFilter = props.filter;
    }

    componentDidMount() {
        var self = this;
        tenants.getTenants(this.props.filter, function(response) {
            self.setState({ data: response.data });
        });
    }

    componentWillUpdate(nextProps, nextState) {
        var self = this;
        if(this.lastFilter != nextProps.filter) {
            this.lastFilter = nextProps.filter;
            tenants.getTenants(this.lastFilter, function(response) {
                self.setState({ data: response.data });
            });
        }
    }

    formatActionOptions(cell, row) {
        if (row.payment_plan_id) {
            return (
                <div>
                    <span class="important-small-blue">On Payment Plan</span>
                </div>
            )
        } else if (!row.has_account){
            return (
                <div>
                    <span class="important-small-orange">Pending Account</span>
                </div>
            )
        } else if (row.waiting_payment_account){
            return (
                <div>
                    <span class="important-small-orange">Pending Payment Setup</span>
                </div>
            )
        }
    }

    formatIndexColumn(cell, row) {
        ++this.index;
        return this.index;
    }

    formatLease(cell, row) {
        if(cell != '0') {
            return (
            <span onClick={this}>
                <NavLink to={"/lease/" + row.contract_id}>View Lease</NavLink>
            </span>
            )
        } else {
            return 'No Lease Active';
        }
    }

    formatEmail(cell, row) {
        return (
            <span onClick={this.bind(row)}>
                <a href="#">{row.tenant_email}</a>
            </span>
        )
    }

    formatScreen(cell, row) {
        if(row.screening !== undefined) {
            return (
                <span onClick={this}>
                    <NavLink to={/tenant/ + row.tenant_id + '/screen'}>Screen Now</NavLink>
                </span>
            )
        } else {
            return (
                <span onClick={this}>
                    <NavLink to={/tenant/ + row.tenant_id}>See Results</NavLink>
                </span>
            )
        }
    }

    didSelectRow(row) {
        browserHistory.push('/tenant/' + row.tenant_id);
    }

    stopSelectRow(e) {
        e.stopPropagation();
    }

    stopSelectEmailRow(e) {
        var self = this;
        e.preventDefault();
        e.stopPropagation();
        var formFields = '<br/><form>' +
            '<div class="row"><div class="col-md-12"><div class="form-group">' +
            '<label>Send Email to ' + this.tenant_email + '</label>' +
            '</br>' +
            '<div class="col-md-12">' +
                '<div class="form-group">' +
                    '<label for="email">Subject</label>' +
'                    <input type="text" value="" class="form-control tenant-info" name="subject" placeholder="Subject" id="emailSubject"/>' +
                '</div>' +
            '</div>' +
            '<div class="col-md-12">' +
                '<div class="form-group">' +
                    '<label for="email">Message</label>' +
                    '<textarea rows="4" cols="80" class="form-control" placeholder="What would you like to say" value="" id="emailMessage"/>' +
                '</div>' +
            '</div>';
        formFields += '</select></div></div></div></form>';
        modal.showPopOverWithDataEntry("Email Tenant", "", formFields, "Send Email", function(e) {
            const data = {
                'message': jQuery('#emailMessage').val(),
                'subject': jQuery('#emailSubject').val(),
                'email': self.tenant_email
            };

            tenants.sendEmail(data, function(response) {
                modal.showInfo("Email was send to " + self.tenant_email, "success", "top", "center");
            })
        });
    }

    render(){
        const self = this;
        var tenantList = this.state;
        var tenantsExist = false;
        if(tenantList != null) {
            if(tenantList.data.length == 0) {
                tenantsExist = false;
            } else {
                tenantsExist = true;
            }

            tenantList = tenantList.data.map(function(tenant) {
                const formatData = {
                    tenant_firstname: tenant.data.tenant_firstname,
                    tenant_lastname: tenant.data.tenant_lastname,
                    tenant_phone: tenant.data.tenant_phone,
                    tenant_phone: tenant.data.tenant_phone,
                    tenant_email: tenant.data.tenant_email,
                    contract_id: tenant.contract_id,
                    tenant_id: tenant[0].tenant_id,
                    payment_plan_id: tenant.payment_plan ? tenant.payment_plan.payment_plan_id : null,
                    has_account: tenant[0].password != null ? true : false,
                    waiting_payment_account: tenant[0].checkbook_api_key != null ? false : true,
                    company: tenant.data.company,
                };
                return formatData;
            });
        }

        const options = {
            onRowClick: this.didSelectRow,
            sizePerPage: 25
        };

        return (
            <div class="content">
                {tenantsExist ? (
                    window.innerWidth < 992 ? (
                    <BootstrapTable data={tenantList} version='4' striped search pagination hover options={options}>
                        <TableHeaderColumn dataField='id' width="50" dataFormat={this.formatIndexColumn} hidden={window.matchMedia('(max-width: 992px)').matches} isKey={ true }></TableHeaderColumn>
                        <TableHeaderColumn dataField='tenant_firstname' dataSort={ true }>Firstname</TableHeaderColumn>
                        <TableHeaderColumn dataField='tenant_lastname' dataSort={ true }>Lastname</TableHeaderColumn>
                        <TableHeaderColumn dataField='contract_id' dataFormat={this.formatLease.bind(this.stopSelectRow)} dataSort={ true }>Lease</TableHeaderColumn>
                    </BootstrapTable>
                    ) : (
                    <BootstrapTable data={tenantList} version='4' striped search pagination hover options={options}>
                        <TableHeaderColumn dataField='id' width="50" dataFormat={this.formatIndexColumn} hidden={window.matchMedia('(max-width: 992px)').matches} isKey={ true }></TableHeaderColumn>
                        <TableHeaderColumn dataField='tenant_firstname' dataSort={ true }>Firstname</TableHeaderColumn>
                        <TableHeaderColumn dataField='tenant_lastname' dataSort={ true }>Lastname</TableHeaderColumn>
                        <TableHeaderColumn dataField='tenant_phone' dataSort={ true }>Phone</TableHeaderColumn>
                        <TableHeaderColumn dataField='company' dataSort={ true }>Company Name</TableHeaderColumn>
                        <TableHeaderColumn dataField='tenant_email' dataFormat={this.formatEmail.bind(this.stopSelectEmailRow)} dataSort={ true }>Email</TableHeaderColumn>
                        <TableHeaderColumn dataField='contract_id' dataFormat={this.formatLease.bind(this.stopSelectRow)} dataSort={ true }>Lease</TableHeaderColumn>
                        <TableHeaderColumn dataAlign='right' dataFormat={this.formatActionOptions}></TableHeaderColumn>
                    </BootstrapTable>
                    )
                ) : (
                    <p>No tenants found.</p>
                )}
            </div>
        )
    }
};


// WEBPACK FOOTER //
// app/components/Tenants/TenantsList.jsx